import validate from "/builds/namicomi/frontend/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@9.28.0_jiti@2.4_b53b74f15580d955d34ca2b221d1d6bb/node_modules/nuxt/dist/pages/runtime/validate.js";
import analytics_45global from "/builds/namicomi/frontend/middleware/analytics.global.ts";
import locale_45global from "/builds/namicomi/frontend/middleware/locale.global.ts";
import persist_45query_45global from "/builds/namicomi/frontend/middleware/persistQuery.global.ts";
import manifest_45route_45rule from "/builds/namicomi/frontend/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@9.28.0_jiti@2.4_b53b74f15580d955d34ca2b221d1d6bb/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  analytics_45global,
  locale_45global,
  persist_45query_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}